var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"d-flex justify-center align-center footer footer-text",attrs:{"height":"32"}},[_vm._v(" Copyright © 2022 Dragon SB. All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }